import { clientEnv } from '@/shared/config/env';
import type { BootstrapResponse } from '@/entities/runtime/types';

export const validateRuntimeConfig = (runtime: BootstrapResponse) => {
  const errors: string[] = [];

  if (runtime.schemaVersion !== 1) {
    errors.push('当前客户端不支持该运行时配置协议');
  }

  if (runtime.siteId !== clientEnv.siteId) {
    errors.push('运行时配置站点与构建站点不一致');
  }

  const requiredSlots = runtime.layoutTemplate.requiredSlots;
  ['compliance_strip', 'responsible_gaming_entry'].forEach((slot) => {
    if (!requiredSlots.includes(slot)) {
      errors.push(`运行时配置缺少强制槽位：${slot}`);
    }
  });

  if (runtime.compliance.minAge < 18) {
    errors.push('合规年龄配置不能低于 18+');
  }

  return errors;
};
